
var $ = require( 'jquery' );

$(document).ready(function() {
    scrollToTop();
})

function scrollToTop() {
    $(window).on('scroll', function () {
        let headerRect = $('.site-header')[0].getBoundingClientRect();

        if (headerRect.top < -100) {
            $('.scroll-to-top').addClass('active');
        } else {
            $('.scroll-to-top').removeClass('active')
        }
    })

    $('.scroll-to-top').on('click', function () {
        $('html, body').animate({
            scrollTop: 0,
        }, 500);
    })
}